import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {
  Box,
  Button,
  DialogContent,
  Grid,
  Link,
  Paper,
  Stack,
  styled,
  Tab,
  Tabs,
  ToggleButton,
  ToggleButtonGroup,
  Typography
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import {
  DataGridPro,
  GridRowsProp,
  GridSelectionModel,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  gridVisibleRowCountSelector,
  useGridApiRef
} from '@mui/x-data-grid-pro';
import axios from 'axios';
import PropTypes from 'prop-types';
import * as React from 'react';
import { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import apiConfig from 'src/api/APIConfig';
import { usePermissionWrapper } from 'src/components/common/hooks/usePermissionWrapper';
import { useUser } from 'src/components/common/hooks/useUser';
import { PopupComponent } from 'src/components/common/PopupComponent';
import SearchHierarchy from 'src/components/layouts/DashboardLayout/SearchHierarchy';
import { AppState, store, useAppSelector } from 'src/store';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import MilestoneGanttChart from './MilestoneGanttChart';
import './MilestoneTracking.scss';

import { QueryModal } from './QueryModal';
import { CustomPagination } from 'src/util/DataTableFooter';

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary
}));

function TabPanel(props: { [x: string]: any; children: any; value: any; index: any }) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}));

const MilestoneTracking = () => {
  const { userName } = useUser();
  const dispatch = useDispatch();
  const { preferedDateFormat, userPreferedDateFormat } = usePreferedDateFormat();
  const [value, setValue] = React.useState(0);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [open, setOpen] = useState(false);
  const [updateStatus, setUpdateStatus] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [siteDataList, setSiteDataList] = useState<any>();
  const [exportPermission, setExportPermission] = useState<boolean>(false);
  const SearchHierarchyDetail: any = useSelector((state: AppState) => state.searchHierarchyDetails);
  const isDataAvailable: any = useAppSelector(state => state.user.user?.userdataavailable);

  const getSelectedRow = (id: any) => {
    setSelectedRowId(id);
    setOpen(true);
  };

  const handleChange = (_event: any, newValue: any) => {
    /**
     * Added if condition when chnage the tabs to set the actuall filter value.
     */
    if (newValue == 0) {
      setSelectionModel([]);
      prevSelectionModel.current = [];
      getData(search.Study, search.Country, search.Site);
    }
    /**
     * End
     */
    setValue(newValue);
  };

  const [pageSize, setPageSize] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [rows, setRows] = React.useState<GridRowsProp>([]);
  const [selectionModel, setSelectionModel] = React.useState<GridSelectionModel>([]);
  const prevSelectionModel = React.useRef<GridSelectionModel>(selectionModel);
  const [search, setSearch] = useState({
    Study: SearchHierarchyDetail?.data[0]?.Study,
    Country: SearchHierarchyDetail?.data[0]?.Country,
    Site: SearchHierarchyDetail?.data[0]?.Site
  });

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    getData(search.Study, search.Country, search.Site);
  }, [siteDataList]);
  const [gridRows, setGridRows] = useState<any>([]);
  const [selectedMilestoneData, setSelectedMilestoneData] = useState<any>({});

  const [gridRowsCount, setGridRowsCount] = React.useState(0);

  const apiRef = useGridApiRef();
  // Only render when the visible columns changes Start
  useEffect(() => {
    if (isDataAvailable) {
      if (apiRef.current !== null) {
        apiRef.current.subscribeEvent('stateChange', () => {
          const count = gridVisibleRowCountSelector(apiRef.current.state);
          setGridRowsCount(count);
          setDocumentUploadInfo();
        });
      }
    }
  }, [apiRef, gridRows]);

  const setDocumentUploadInfo = () => {
    if (document.getElementById('pictms-milestone-all-id') == null) {
      const newElement = document.createElement('span');
      newElement.setAttribute('id', 'pictms-milestone-all-id');
      newElement.innerHTML = 'All';
      const referenceElement: any = document.querySelector(
        '.MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderDraggableContainer'
      );
      if (referenceElement !== null) {
        referenceElement.parentNode.insertBefore(newElement, referenceElement.nextSibling);
      } else {
        const allElement = document.getElementById('pictms-milestone-all-id');
        if (allElement !== null) {
          allElement.remove();
        }
      }
    } else {
      const referenceElement: any = document.querySelector(
        '.MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderDraggableContainer'
      );
      if (referenceElement == null) {
        const allElement = document.getElementById('pictms-milestone-all-id');
        if (allElement !== null) {
          allElement.remove();
        }
      }
    }
  };

  let view_permission = false;
  const getData = async (study: string, country: string, site: string) => {
    setIsLoading(false);
    setGridRows([]);
    setGridRowsCount(0);
    setSearch({ ...search, Study: study, Country: country, Site: site });
    if (study !== '--' && country !== '--' && site !== '--') {
      const result = siteDataList.find(({ name }: any) => name === site);
      const group_name = result.role;
      const url = `${apiConfig.appConfig.apiutils}/sysAdmin/groups/${group_name}/clientRoles/ctms-ui`;
      const response = await axios.get(url);
      const viewresult = response.data.find(({ name }: any) => name === 'VIEW_SITE_MILESTONE_DETAILS');
      if (viewresult !== undefined) view_permission = true;
      const exportresult = response.data.find(({ name }: any) => name === 'EXPORT_SITE_MILESTONES');
      if (exportresult !== undefined) setExportPermission(true);
    }
    if (study !== '--' && site !== '--' && view_permission === true) {
      try {
        setIsLoading(true);
        const url = `${apiConfig.appConfig.apictms}/site/milestone/${site}/${study}/getAll?tmf_doc_level=Site&country=${country}&application=ETMF`;
        const response = await axios.get(url);
        const updated = response.data.map((item: any, index: any) => {
          return {
            id: item.milestone_id,
            ...item,
            document_progress: `${item.doc_approved_count}/${item.doc_total_count} Approved`
          };
        });
        setGridRows(updated);
        setGridRowsCount(updated.length);
        setIsLoading(false);
        setDocumentUploadInfo();
      } catch (error: any) {
        setIsLoading(false);
        setGridRows([]);
        setGridRowsCount(0);
        store.dispatch(setSnackbarMessage('Error loading details', 'error'));
        if (error.response.status === 403) {
          store.dispatch(setSnackbarMessage('Error 403 Restricted User permission', 'error'));
        } else if (error.response.status === 401) {
          store.dispatch(setSnackbarMessage('Error 401 Unauthorized access', 'error'));
        }
      }
    }
  };

  const addSelectedMilestoneRowData = async (selectedMilestoneRows: any[]) => {
    let statusMilestoneData: any[];
    const prepareMilestoneData = selectedMilestoneRows.map(rowId => {
      return gridRows.find((item: any) => item.milestone_id == rowId);
    });

    if (updateStatus === 'Completed') {
      statusMilestoneData = prepareMilestoneData
        .filter((milestone: any) => {
          return checkCompletedCriteria(milestone);
        })
        .map((milestone: any) => {
          return milestone;
        });
      const isCompletedExists = prepareMilestoneData.some((item: any) => item.milestone_status === 'Completed');
      if (statusMilestoneData.length > 0) {
        if (statusMilestoneData.length != prepareMilestoneData.length) {
          if (isCompletedExists) {
            store.dispatch(setSnackbarMessage('Status change successful', 'success'));
          } else {
            store.dispatch(setSnackbarMessage('Date is Blank or future date entered.', 'error'));
          }
        }
        setUpdateMilestoneData(statusMilestoneData);
      } else {
        if (!isCompletedExists) {
          store.dispatch(setSnackbarMessage('Date is Blank or future date entered.', 'error'));
        } else {
          store.dispatch(setSnackbarMessage('No change in status', 'success'));
        }

        setUpdateStatus('');
      }
    } else if (updateStatus === 'In progress') {
      statusMilestoneData = prepareMilestoneData
        .filter((milestone: any) => {
          return checkInProgressCriteria(milestone);
        })
        .map((milestone: any) => {
          return milestone;
        });
      const isInProgressExists = prepareMilestoneData.some((item: any) => item.milestone_status === 'In progress');

      if (statusMilestoneData.length > 0) {
        if (statusMilestoneData.length != prepareMilestoneData.length) {
          if (isInProgressExists) {
            store.dispatch(setSnackbarMessage('Status change successful', 'success'));
          } else {
            store.dispatch(setSnackbarMessage('Actual start date is Blank', 'error'));
          }
        }
        setUpdateMilestoneData(statusMilestoneData);
      } else {
        if (!isInProgressExists) {
          const isCompletedExists = prepareMilestoneData.some((item: any) => item.milestone_status === 'Completed');
          if (isCompletedExists) {
            store.dispatch(setSnackbarMessage('No change in status', 'success'));
          } else {
            store.dispatch(setSnackbarMessage('Actual start date is Blank', 'error'));
          }
        } else {
          store.dispatch(setSnackbarMessage('No change in status', 'success'));
        }
        setUpdateStatus('');
      }
    } else if (updateStatus === 'Not applicable') {
      statusMilestoneData = prepareMilestoneData
        .filter((milestone: any) => {
          return checkNotApplicableCriteria(milestone);
        })
        .map((milestone: any) => {
          return milestone;
        });
      if (statusMilestoneData.length > 0) {
        if (statusMilestoneData.length != prepareMilestoneData.length) {
          const isNotApplicableExists = prepareMilestoneData.some(
            (item: any) => item.milestone_status === 'Not applicable'
          );
          if (isNotApplicableExists) {
            store.dispatch(setSnackbarMessage('Status change successful', 'success'));
          } else {
            store.dispatch(setSnackbarMessage('Status change successful', 'success'));
          }
        }
        setUpdateMilestoneData(statusMilestoneData);
      } else {
        store.dispatch(setSnackbarMessage('No change in status', 'error'));
        setUpdateStatus('');
      }
    } else if (updateStatus === 'On hold') {
      statusMilestoneData = prepareMilestoneData
        .filter((milestone: any) => {
          return checkOnHoldCriteria(milestone);
        })
        .map((milestone: any) => {
          return milestone;
        });
      if (statusMilestoneData.length > 0) {
        if (statusMilestoneData.length != prepareMilestoneData.length) {
          const isOnHoldExists = prepareMilestoneData.some((item: any) => item.milestone_status === 'On hold');
          if (isOnHoldExists) {
            store.dispatch(setSnackbarMessage('Status change successful', 'success'));
          } else {
            store.dispatch(setSnackbarMessage('Status change successful', 'success'));
          }
        }
        setUpdateMilestoneData(statusMilestoneData);
      } else {
        store.dispatch(setSnackbarMessage('No change in status', 'error'));
        setUpdateStatus('');
      }
    }
  };

  const setUpdateMilestoneData = (milestones: any[]) => {
    setSelectedMilestoneData({
      milestone_ids: milestones.map((item: any) => item.milestone_id),
      milestone_status: updateStatus,
      updated_by: userName
    });
  };

  const checkCompletedCriteria = (milestone: any): any => {
    const actualStartDate = new Date(milestone.start_date_actual);
    const actualEndDate = new Date(milestone.end_date_actual);
    if (
      actualStartDate <= new Date() &&
      actualEndDate <= new Date() &&
      milestone.start_date_actual !== '' &&
      milestone.end_date_actual != '' &&
      milestone.start_date_actual !== null &&
      milestone.end_date_actual !== null &&
      milestone.milestone_status !== 'Completed' &&
      milestone.milestone_status !== 'Not set' &&
      milestone.milestone_status !== 'Planned'
    ) {
      return true;
    } else {
      return false;
    }
  };

  const checkInProgressCriteria = (milestone: any): any => {
    const actualStartDate = new Date(milestone.start_date_actual);
    if (
      actualStartDate <= new Date() &&
      milestone.start_date_actual !== '' &&
      milestone.start_date_actual !== null &&
      milestone.milestone_status !== 'In progress' &&
      milestone.milestone_status !== 'Completed' &&
      milestone.milestone_status !== 'Not set' &&
      milestone.milestone_status !== 'Overdue'
    ) {
      return true;
    } else {
      return false;
    }
  };

  const checkNotApplicableCriteria = (milestone: any): any => {
    if (milestone.milestone_status !== 'Completed' && milestone.milestone_status !== 'Not applicable') {
      return true;
    } else {
      return false;
    }
  };

  const checkOnHoldCriteria = (milestone: any): any => {
    if (milestone.milestone_status !== 'Completed' && milestone.milestone_status !== 'On hold') {
      return true;
    } else {
      return false;
    }
  };
  useEffect(() => {
    if (updateStatus !== '') {
      addSelectedMilestoneRowData(getSelctionAfterFilter());
    }
  }, [updateStatus]);

  useEffect(() => {
    if (Object.keys(selectedMilestoneData).length !== 0) {
      updateMilestoneDataStatus(selectedMilestoneData, search.Study, search.Country, search.Site);
    }
  }, [selectedMilestoneData]);

  const updateMilestoneDataStatus = async (
    selectedMilestoneData: any,
    study: string,
    country: string,
    site: string
  ) => {
    try {
      setIsLoading(true);
      const url = `${apiConfig.appConfig.apictms}/site/milestone/${site}/${study}/update`;
      const response = await axios.put(url, selectedMilestoneData);

      store.dispatch(setSnackbarMessage('Data Updated', 'success'));

      selectionModel.map((item: any) => {
        gridRows.map((rowData: any) => {
          if (rowData.milestone_id === item) {
            if (selectedMilestoneData.milestone_ids.includes(rowData.milestone_id)) {
              const rowIndex = gridRows.findIndex((obj: any) => obj.milestone_id === item);
              gridRows[rowIndex].milestone_status = updateStatus;
              gridRows[rowIndex].updated_by = userName;
            }
          }
        });
      });
      setUpdateStatus('');
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      store.dispatch(setSnackbarMessage('Error in status change', 'error'));
      setUpdateStatus('');
    }
  };

  const loadServerRows = (page: number, data: any): Promise<any> => {
    return new Promise(resolve => {
      resolve(data.slice(page * pageSize, (page + 1) * pageSize));
    });
  };

  useEffect(() => {
    let active = true;
    (async () => {
      const newRows = await loadServerRows(page, gridRows);
      if (!active) {
        return;
      }
      setRows(newRows);
      setTimeout(() => {
        setSelectionModel(prevSelectionModel.current);
      });
    })();
    return () => {
      active = false;
    };
  }, [page, pageSize, gridRows]);

  const formatDate = (params: any) => {
    return preferedDateFormat(params.value);
  };
  const { checkPermission } = usePermissionWrapper();
  const [isDisable, setIsDisble] = useState(false);
  const columns = [
    {
      field: 'major_milestone',
      headerName: 'Major Milestone',
      width: 180
    },
    {
      field: 'minor_milestone',
      headerName: 'Minor Milestone',
      width: 180,
      renderCell: (params: any) =>
        checkPermission('view_milstone_details') ? (
          <Link onClick={() => getSelectedRow(params.row.milestone_id)}>{params.value!.toString()}</Link>
        ) : (
          params.value!.toString()
        )
    },
    {
      field: 'milestone_status',
      headerName: 'Milestone Status',
      width: 150,
      type: 'singleSelect',
      valueOptions: ['Not applicable', 'On hold', 'Not set', 'Planned', 'In progress', 'Completed', 'Overdue']
    },
    {
      field: 'document_progress',
      headerName: 'Document Progress',
      width: 150
    },
    {
      field: 'start_date_planned_baseline',
      headerName: 'Start Date Planned Baseline',
      width: 150,
      type: 'date',
      valueGetter: formatDate
    },
    {
      field: 'start_date_adjusted',
      headerName: 'Start Date Adjusted',
      width: 150,
      type: 'date',
      valueGetter: formatDate
    },
    {
      field: 'start_date_actual',
      headerName: 'Start Date Actual',
      width: 150,
      type: 'date',
      valueGetter: formatDate
    },
    {
      field: 'end_date_planned_baseline',
      headerName: 'End Date Planned Baseline',
      width: 150,
      type: 'date',
      valueGetter: formatDate
    },
    {
      field: 'end_date_adjusted',
      headerName: 'End Date Adjusted',
      width: 150,
      type: 'date',
      valueGetter: formatDate
    },
    {
      field: 'end_date_actual',
      headerName: 'End Date Actual',
      width: 150,
      type: 'date',
      valueGetter: formatDate
    },
    {
      field: 'date_last_update',
      headerName: 'Date Last Updated',
      width: 150,
      type: 'date',
      valueGetter: formatDate
    },
    {
      field: 'milestone_level',
      headerName: 'Milestone Level',
      width: 150
    },
    {
      field: 'priority',
      headerName: 'Priority',
      width: 150
    },
    {
      field: 'updated_by',
      headerName: 'Updated By',
      width: 150
    },
    {
      field: 'assigned_to',
      headerName: 'Assigned To',
      width: 150
    },
    {
      field: 'pi_name',
      headerName: 'PI Name',
      width: 150
    }
  ];
  const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
    id: false
  });
  const [paginationVal, setPaginationVal] = useState(true);
  const DataGridComponent = DataGridPro;
  const getSelctionAfterFilter = () => {
    try {
      if (Object.entries(apiRef.current.state.filter.filteredRowsLookup).length === 0) {
        return selectionModel;
      } else {
        const filtered = Object.entries(apiRef.current.state.filter.filteredRowsLookup).filter(a => a[1] === true);
        const filteredIds = filtered.map(a => a[0]);
        const filterdSelectionRows = selectionModel.filter(item => filteredIds.includes(item.toString()));
        return filterdSelectionRows;
      }
    } catch (e) {
      return selectionModel;
    }
  };
  const getSelctionCountAfterFilter = () => getSelctionAfterFilter().length;

  const currentDate = new Date();
  const [viewModeType, setviewModeType] = useState<any>('All');
  const [currentYear, setCurrentYear] = useState(currentDate.getFullYear());
  const [currentMonth, setCurrentMonth] = useState(currentDate.getMonth() + 1);
  const [currentMonthDate, setCurrentMonthDate] = useState(
    currentYear + '-' + currentMonth + '-' + new Date(currentYear, currentMonth, 0).getDate()
  );

  const onClickDecrease = () => {
    if (viewModeType == 'Month') {
      setCurrentYear(currentYear - 1);
    }
    if (currentMonth > 1 && viewModeType == 'Day') {
      setCurrentMonthDate(
        currentDate.getFullYear() +
          '-' +
          (currentMonth - 1) +
          '-' +
          new Date(currentYear - 1, currentMonth - 1, 0).getDate()
      );
      setCurrentMonth(currentMonth - 1);
    }
  };
  const onClickIncrease = () => {
    if (viewModeType == 'Month') {
      setCurrentYear(currentYear + 1);
    }
    if (currentMonth < 12 && viewModeType == 'Day') {
      setCurrentMonthDate(
        currentDate.getFullYear() +
          '-' +
          (currentMonth + 1) +
          '-' +
          new Date(currentYear + 1, currentMonth + 1, 0).getDate()
      );
      setCurrentMonth(currentMonth + 1);
    }
  };

  const handleViewModeChange = (event: React.MouseEvent<HTMLElement>, viewMode: any) => {
    setviewModeType(viewMode);
    setCurrentMonthDate(
      currentDate.getFullYear() +
        '-' +
        (currentDate.getMonth() + 1) +
        '-' +
        new Date(currentDate.getMonth() + 1, currentDate.getFullYear(), 0).getDate()
    );
    setCurrentMonth(currentDate.getMonth() + 1);
    setCurrentYear(currentDate.getFullYear());
  };
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton onResize={undefined} onResizeCapture={undefined} />
        <GridToolbarFilterButton onResize={undefined} onResizeCapture={undefined} />
        <GridToolbarDensitySelector onResize={undefined} onResizeCapture={undefined} />
        <GridToolbarExport
          // disabled={!exportPermission}
          printOptions={{ disableToolbarButton: !checkPermission('print_milestones') ? true : false }}
          csvOptions={{ disableToolbarButton: !checkPermission('export_milestones') ? true : false }}
        />

        {/* componentsProps={{ toolbar: { printOptions: { disableToolbarButton:!checkPermission('print_milestones') ? true : false } } }} */}
      </GridToolbarContainer>
    );
  }
  return (
    <>
      <SearchHierarchy searchData={getData} setSiteDataList={setSiteDataList} />
      <div className="milestone-page">
        {isDataAvailable !== null && isDataAvailable === false ? (
          <div className="no-data-class">
            <h3>No Data access available!</h3>
          </div>
        ) : (
          <Grid container>
            <Grid md={12}>
              <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label="Milestone Planner View" {...a11yProps(0)} />
                    <Tab label="Gantt View" {...a11yProps(1)} />
                  </Tabs>
                </Box>
                <TabPanel value={value} index={0} className="milestone-view-block">
                  <Grid container>
                    <Grid md={12}>
                      <div style={{ height: '80vh', width: '100%' }}>
                        <DataGridComponent
                          apiRef={apiRef}
                          className="milestone-datagrid"
                          components={{
                            //Toolbar: GridToolbar
                            Toolbar: CustomToolbar,
                            Pagination: CustomPagination
                          }}
                          rows={gridRows}
                          columns={columns}
                          checkboxSelection={isDisable}
                          checkboxSelectionVisibleOnly={true}
                          //isRowSelectable={(params: GridRowParams) => params.row.is_update_eligible }
                          disableSelectionOnClick={!isDisable}
                          pageSize={pageSize}
                          rowCount={gridRowsCount}
                          onPageChange={newPage => {
                            prevSelectionModel.current = selectionModel;
                            setPage(newPage);
                          }}
                          onPageSizeChange={newPageSize => setPageSize(newPageSize)}
                          rowsPerPageOptions={[10, 20, 30]}
                          pagination={paginationVal}
                          onSelectionModelChange={newSelection => setSelectionModel(newSelection)}
                          selectionModel={selectionModel}
                          columnVisibilityModel={columnVisibilityModel}
                          onColumnVisibilityModelChange={(newModel: any) => {
                            setColumnVisibilityModel(newModel);
                            const hideColumsArr: any = [];
                            for (const obj of columns) {
                              if (newModel[obj.field] == false) {
                                hideColumsArr.push(false);
                              } else {
                                hideColumsArr.push(true);
                              }
                            }

                            if (hideColumsArr.includes(true)) {
                              setPaginationVal(true);
                            } else {
                              setPaginationVal(false);
                            }
                          }}
                        />
                      </div>
                    </Grid>
                  </Grid>

                  <Grid container className="button-section">
                    {isDisable ? (
                      <Grid md={12}>
                        <p>{selectionModel.length === 0 ? 'No' : getSelctionCountAfterFilter()} Milestones Selected</p>
                      </Grid>
                    ) : (
                      <></>
                    )}
                  </Grid>

                  <Grid container spacing={2} className="button-section">
                    <Grid item md={10}>
                      <Stack spacing={2} direction="row">
                        {isDisable ? (
                          <Button
                            variant="contained"
                            disabled={selectionModel.length === 0 ? true : getSelctionCountAfterFilter() === 0}
                            onClick={() => setUpdateStatus('In progress')}
                          >
                            SET IN PROGRESS
                          </Button>
                        ) : (
                          ''
                        )}
                        {isDisable ? (
                          <Button
                            variant="contained"
                            disabled={
                              selectionModel.length === 0 && !isDisable ? true : getSelctionCountAfterFilter() === 0
                            }
                            onClick={() => setUpdateStatus('On hold')}
                          >
                            SET ON HOLD
                          </Button>
                        ) : (
                          ''
                        )}
                        {isDisable ? (
                          <Button
                            variant="contained"
                            disabled={
                              selectionModel.length === 0 && !isDisable ? true : getSelctionCountAfterFilter() === 0
                            }
                            onClick={() => setUpdateStatus('Not applicable')}
                          >
                            NOT APPLICABLE
                          </Button>
                        ) : (
                          ''
                        )}
                        {isDisable ? (
                          <Button
                            variant="contained"
                            disabled={
                              selectionModel.length === 0 && !isDisable ? true : getSelctionCountAfterFilter() === 0
                            }
                            onClick={() => setUpdateStatus('Completed')}
                          >
                            COMPLETED
                          </Button>
                        ) : (
                          ''
                        )}
                      </Stack>
                    </Grid>
                  </Grid>
                  {/* </PermissionWrapper>
                {/* {currentTabinfo[0].NextButton && (
                  <Grid item md={2} display="flex" justifyContent="flex-end">
                    <Item>
                      <Stack spacing={2} direction="row">
                        <Button onClick={handleNextbtn} variant="contained">
                          NEXT
                        </Button>
                      </Stack>
                    </Item>
                  </Grid>
                )} 
              </Grid> */}
                  <div>
                    {selectedRowId !== null && (
                      <PopupComponent
                        aria-labelledby="customized-dialog-title"
                        open={open}
                        maxWidth="lg"
                        className="milestone-modal"
                      >
                        <DialogContent dividers>
                          <QueryModal
                            getData={getData}
                            handleClose={handleClose}
                            gridRows={gridRows}
                            selectedRowId={selectedRowId}
                            studyId={search.Study}
                            country={search.Country}
                            siteId={search.Site}
                          />
                        </DialogContent>
                      </PopupComponent>
                    )}
                  </div>
                </TabPanel>
                <TabPanel value={value} index={1} className="milestone-view-block">
                  <Grid container>
                    <Grid md={12}>
                      <div className="gannt-filter-section">
                        {viewModeType != 'All' && (
                          <div className="year-section">
                            <Button onClick={() => onClickDecrease()}>
                              <ArrowBackIosIcon></ArrowBackIosIcon>
                            </Button>
                            {viewModeType == 'Day' ? monthNames[currentMonth - 1] : currentYear}
                            <Button onClick={() => onClickIncrease()}>
                              <ArrowForwardIosIcon></ArrowForwardIosIcon>
                            </Button>
                          </div>
                        )}
                        <ToggleButtonGroup
                          sx={{ display: 'flex', justifyContent: 'flex-end' }}
                          size="small"
                          color="info"
                          value={viewModeType}
                          exclusive
                          onChange={handleViewModeChange}
                          className="year-month-block"
                        >
                          <ToggleButton value="All">All</ToggleButton>
                          <ToggleButton value="Month">Year</ToggleButton>
                          <ToggleButton value="Day">Month</ToggleButton>
                        </ToggleButtonGroup>
                      </div>
                      <div style={{ height: 480, width: '100%' }}>
                        <MilestoneGanttChart
                          currentMonth={currentMonth}
                          currentYear={currentYear}
                          viewModeType={viewModeType}
                          currentMonthDate={currentMonthDate}
                          search={search}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </TabPanel>
              </Box>
            </Grid>
          </Grid>
        )}
      </div>
    </>
  );
};

export default memo(MilestoneTracking);
